module.exports = __webpack_public_path__ + "img/a-dot.62551e4d.png";